import { Injectable } from '@angular/core';
import { Apollo, QueryRef, gql } from 'apollo-angular';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GraphqlService {

  constructor(private apollo: Apollo) { }

  getQuery(query: any, variables = {}): Observable<any> {
    return this.apollo.query({
      query: query,
      variables: variables
    });
  }

  getQuery2(query: any, variables = {}): QueryRef<any> {
    return this.apollo.watchQuery({
      query: query,
      variables: variables
    });
  }
}
